import React from 'react';
import { aboutContent, aboutImage } from '../data/mock';

const AboutPage = () => {
  return (
    <div className="min-h-screen pt-24 md:pt-32 bg-white">
      {/* Hero Section */}
      <section className="container-luxury">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <div className="order-2 lg:order-1 animate-fade-in-up">
            <div className="image-luxury aspect-[3/4]">
              <img
                src={aboutImage}
                alt="Anaé Vilnor - Photographe"
                className="grayscale"
              />
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2 space-y-8">
            <div className="animate-fade-in-up">
              <h1 className="section-title text-[#111111] mb-6">
                À Propos
              </h1>
              <div className="w-16 h-px bg-[#111111] mb-8" />
            </div>

            {/* Quote */}
            <blockquote className="animate-fade-in-up animation-delay-1">
              <p className="quote-text text-[#111111]">
                "{aboutContent.quote}"
              </p>
            </blockquote>

            {/* Bio */}
            <div className="space-y-6 animate-fade-in-up animation-delay-2">
              <p className="body-text text-[#666666]">
                {aboutContent.bio}
              </p>
              <p className="body-text text-[#666666]">
                {aboutContent.approach}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Influences Section */}
      <section className="container-luxury section-spacing-large">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="nav-link text-[#9A9A9A] mb-8 animate-fade-in-up">
            Influences
          </h2>
          <div className="flex flex-wrap justify-center gap-x-12 gap-y-4">
            {aboutContent.influences.map((influence, index) => (
              <span 
                key={influence}
                className="font-serif text-xl text-[#111111] animate-fade-in-up"
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                {influence}
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* Artistic Approach */}
      <section className="bg-[#F5F5F5]">
        <div className="container-luxury section-spacing">
          <div className="max-w-3xl mx-auto">
            <h2 className="nav-link text-[#9A9A9A] mb-8 text-center animate-fade-in-up">
              Démarche Artistique
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
              <div className="animate-fade-in-up animation-delay-1">
                <span className="font-serif text-4xl text-[#111111]">01</span>
                <p className="caption-text mt-4">Observer</p>
                <p className="body-text text-[#666666] mt-2 text-sm">
                  Patience et attention aux détails invisibles
                </p>
              </div>
              <div className="animate-fade-in-up animation-delay-2">
                <span className="font-serif text-4xl text-[#111111]">02</span>
                <p className="caption-text mt-4">Capturer</p>
                <p className="body-text text-[#666666] mt-2 text-sm">
                  L'instant suspendu entre l'ombre et la lumière
                </p>
              </div>
              <div className="animate-fade-in-up animation-delay-3">
                <span className="font-serif text-4xl text-[#111111]">03</span>
                <p className="caption-text mt-4">Révéler</p>
                <p className="body-text text-[#666666] mt-2 text-sm">
                  L'émotion brute derrière chaque regard
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
